export default __webpack_public_path__ + "static/media/success.8b18e3b4.svg";